import { render, staticRenderFns } from "./BatchEditBrands.vue?vue&type=template&id=69f87fcf&"
import script from "./BatchEditBrands.vue?vue&type=script&lang=js&"
export * from "./BatchEditBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports